import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const InvoiceTypeOutgoing = () => {
  return (
    <SettingsMetaData propertyName={"InvoiceType_Outgoing"} viewPropertyName={"Invoice Type"} />
  );
};
export default InvoiceTypeOutgoing;